import React, { useEffect } from "react";
import CustomPopupDialog from "../../components/global/CustomPopupDialog/CustomPopupDialog";
import EmailDocumentsDialog from "./EmailDocumentsDialog";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EmailInvoiceDocument, invoiceSelector } from "../../features/invoice/invoiceSlice";
import { useForm } from "react-hook-form";
import { setValidationCss } from "../../common/utils";
import { ToastContainer, toast } from "react-toastify";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import {
  GetFileSummaryExpress,
  orderSliceSelector,
} from "../../features/orders/orderSlice";
import { languageSelector } from "../../features/language/languageSlice";

const InvoiceSummary = ({
  setinvoiceSummary,
  invoiceDetails,
  setspayCheckedInvoices,
  setShowInvoiceSummary,
  t,
}) => {
  // console.log("outstanding invoices", invoiceDetails.original);
  const { fileSummaryDetails } = useSelector(orderSliceSelector);
  const dispatch = useDispatch();
  const { invoiceLineDetails, invoiceTotals } = useSelector(invoiceSelector);
  const { userLogin } = useSelector(authLoginSelector);
  const [EmailDocuments, setEmailDocuments] = useState(false);
  const [emailList, setEmailList] = useState([]);
  const lang = useSelector(languageSelector);
  // const [emailList, setEmailList] = useState([
  //     { email: userLogin?.email, username: userLogin?.loginName },
  //   ]);
  const [isEmailValid, setEmailValid] = useState(true);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  let emailIDs = [];
  const addEmailClick = (e) => {
    let val = getValues();
    let err = errors;
    emailList.map((item, index) => {
      return emailIDs.push({ email: item.email, username: item.username });
    });
    if (emailValidation(val.email)) {
      emailIDs.push({ email: val.email, username: val.email });
    }
    setEmailList(emailIDs);
    setValue(`email`, "");
  };

  function emailValidation(val) {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (val === "" || val === null || val === undefined) {
     setEmailValid(false);
      setEmailErrorMessage(t("EmailRequired"));
      return false;
    }
    if (regex.test(val) === false) {
      setEmailValid(false);
      setEmailErrorMessage(t("invalidEmailError"));
      return false;
    }
    setEmailValid(true);
    setEmailErrorMessage("");
    return true;
  }

  useEffect(() => {
    if (fileSummaryDetails === null) {
      dispatch(
        GetFileSummaryExpress(
          invoiceDetails?.original?.fileID,
          userLogin?.userId
        )
      );
    } else {
      if (
        fileSummaryDetails?.lawyerEmail !== null &&
        fileSummaryDetails?.lawyerEmail !== "" &&
        fileSummaryDetails?.lawyerName !== ""
      ) {
        // setlaywerEmailContact({
        //   lawyerName: fileSummaryDetails?.lawyerName,
        //   lawyeremail: fileSummaryDetails?.lawyerEmail,
        // });
        emailIDs.push({
          email: fileSummaryDetails?.lawyerEmail,
          username: fileSummaryDetails?.lawyerName,
        });
      }
      if (
        fileSummaryDetails?.orderingLawyerEmail !== null &&
        fileSummaryDetails?.orderingLawyerEmail !== "" &&
        fileSummaryDetails?.orderingLawyerEmail !==
        fileSummaryDetails?.lawyerEmail &&
        fileSummaryDetails?.orderingLawyerName !== ""
      ) {
        emailIDs.push({
          email: fileSummaryDetails?.orderingLawyerEmail,
          username: fileSummaryDetails?.orderingLawyerName,
        });
      }
      if (
        fileSummaryDetails?.assistantEmail !== null &&
        fileSummaryDetails?.assistantEmail !== "" &&
        fileSummaryDetails?.assistantName !== ""
      ) {
        emailIDs.push({
          email: fileSummaryDetails?.assistantEmail,
          username: fileSummaryDetails?.assistantName,
        });
      }
      setEmailList(emailIDs);
    }
    console.log("fileSummaryDetails", fileSummaryDetails);
  }, [fileSummaryDetails]);

  const sendEmailClick = (e) => {
    let val = getValues();
    if (
      (!Array.isArray(val.emailArray) && val.emailArray === false) ||
      (Array.isArray(val.emailArray) && val.emailArray.length === 0)
    ) {
      setisemailIDSelected(true);
      //setdocErrorMessage("Select Email Address");
    } else {
      setisemailIDSelected(false);
      let req = {
        FileID: invoiceDetails?.original?.fileID,
        InvoiceID: invoiceDetails?.original?.invoiceID,
        UserID: userLogin?.userId,
        EmailAddress: val?.emailArray.join(';'),
        Language: lang?.value === "fr" ? "french" : "english",
      };
      setValue(`email`, "");
      dispatch(EmailInvoiceDocument(req, { toast }));
      setEmailDocuments(false);
    }
    //MoveUP();
  };
  const [isemailIDSelected, setisemailIDSelected] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    trigger,
    control,
    watch,
    formState: { errors },
  } = useForm();

  return (
    <div>
      <div className="w-auto flex mb-[24px]">
        <button
          onClick={() => { setinvoiceSummary(false); setShowInvoiceSummary(false); }}
          className="cursor-pointer"
          aria-label="Orders page return button"
        >
          <div className="flex justify-items-start mr-[4px]">
            <p className="mr-[4px] text-secondary-blue-link">
              {t("MakeaPayment")}
            </p>
            <svg width="20" height="20" fill="none">
              <path
                d="m7.308 15.922 5.384-5.923-5.384-5.923"
                stroke="#A09F9F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </button>
        <button
          onClick={() => { setinvoiceSummary(false); setShowInvoiceSummary(false); }}
          className="cursor-pointer"
          aria-label="Orders page return button"
        >
          <div className="flex justify-items-start mr-[4px]">
            <p className="mr-[4px] text-secondary-blue-link">
              {t("OutstandingInvoices")}
            </p>
            <svg width="20" height="20" fill="none">
              <path
                d="m7.308 15.922 5.384-5.923-5.384-5.923"
                stroke="#A09F9F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </button>
        <h1 className="font-bold mt-2">
          {t("InvoiceNo")} {invoiceDetails?.original?.invoiceID}
        </h1>

        <div className="ml-auto mr-0">
          <button
            className="flex focus:bg-[#F8F8F8] font-semibold h-[40px] hover:bg-[#F8F8F8] outline-neutrals-black px-4 rounded-sm"
            onClick={() => { setinvoiceSummary(null); setShowInvoiceSummary(false); }}
          >
            {/* <img
              aria-hidden="true"
              className="h-[12px] mr-4 mt-[6px] w-[12px]"
              src="../../arrow-left.e8cef756.svg"
              alt="back arrow"
            /> */}
            {"< "} Back
          </button>
        </div>
      </div>
      <div
        className="!h-[auto] !w-[1060px] border border-[#A09F9F] rounded-[3px]"
        style={{ margin: "0 auto", marginBottom: "10%" }}
      >
        <div>
          <div className="!w-[1018px] flex items-center justify-center mb-[40px] mt-[40px] pl-[40px]">
            <div>
              <h1 className="!font-semibold text-[22px]">
                {t(t("Invoice"))} - {invoiceDetails?.original?.invoiceID}
              </h1>
            </div>
            <div className="ml-auto mr-0">
              <button
                id="pay-invoice"
                className="bg-primary-yellow font-[600] font-open-sans h-[40px] leading-[19.07px] px-[14px] rounded-sm text-[16px] w-[158px]"
                onClick={() => {
                  setspayCheckedInvoices(true);
                  setShowInvoiceSummary(false);
                }}
              >
                Pay Invoice
              </button>
            </div>
          </div>
          <div className="!w-[1018px] flex mb-[12px] pl-[40px]">
            <div className="flex flex-col">
              <div className="flex flex-row mb-2">
                <h1 className="!font-semibold mr-2 text-[16px]">Order No:</h1>
                <p>{invoiceDetails?.original?.fileNumber}</p>
              </div>
              <div className="flex flex-row mb-2">
                <h1 className="!font-semibold mr-2 text-[16px]">
                  Your File/Reference No:
                </h1>
                <p>{invoiceDetails?.original?.referenceNumber}</p>
              </div>
              <div className="flex flex-row">
                <div className="flex flex-row">
                  <h1 className="!font-semibold mr-2 text-[16px]">Client Name:</h1>
                  <p>{invoiceDetails?.original?.clients}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row left-82 pb-2">
            <button
              className="pr-2 pl-2 break-normal btn__secondary flex flex-row font-[600] gap-[8px] h-[40px] items-center justify-center leading-[21.79px] my-auto text-[16px] w-auto"
              onClick={() => {setEmailErrorMessage("");setEmailValid(true);setEmailDocuments(true)}}
              id="email_quote_button"
            >
              <img src="images/email.a1546b05.svg" alt="email" /> Email
              Invoice
            </button>
          </div>
          <div className="!w-[1018px] flex items-center justify-center pl-[40px]">
            {/* <div className="flex mr-[32px]">
              <h1 className="!font-semibold mr-2 text-[16px]">
                Mailing address:
              </h1>
              <p>12345 Richmond Street W., Toronto ON.</p>
            </div> */}
          </div>
          {/* {EmailDocuments && (
                <EmailDocumentsDialog 
                setEmailDocuments={setEmailDocuments}
                 t={t} 
                 register={register} 
                 setValidationCss={setValidationCss}
                 isEmailSelected={1}
                emailList={emailList}
                addEmailClick={addEmailClick}
                isEmailValid={isEmailValid}
                sendEmailClick={sendEmailClick}
                isemailIDSelected={isemailIDSelected}
                ToastContainer={ToastContainer}

                 />
          )} */}

          {EmailDocuments && (
            <CustomPopupDialog
              component={
                <EmailDocumentsDialog
                  setEmailDocuments={setEmailDocuments}
                  t={t}
                  register={register}
                  setValidationCss={setValidationCss}
                  isEmailSelected={1}
                  emailList={emailList}
                  addEmailClick={addEmailClick}
                  isEmailValid={isEmailValid}
                  emailErrorMessage={emailErrorMessage}
                  sendEmailClick={sendEmailClick}
                  isemailIDSelected={isemailIDSelected}
                  ToastContainer={ToastContainer}
                />
              }
            />
          )}
        </div>
        <div
          className="!w-[980px] border border-[#A09F9F] rounded-[3px]"
          style={{ margin: "0 auto", marginBottom: "3%" }}
        >
          <div className="border-[#d9d9d9] border-[1px] flex flex-col font-open-sans rounded-[2px]">
            <div className="bg-[#FFF6DF] border-[#dbdada] border-b flex flex-row font-[600] leading-[21.79px] px-[32px] py-[14px] text-[16px] w-full">
              <div className="w-[66%]">Fee Description</div>
              <div className="text-right w-[7%]">#</div>
              <div className="text-end w-[15%]">Rate</div>
              <div className="text-end w-[12%]">Total</div>
            </div>

            {invoiceLineDetails &&
              invoiceLineDetails?.length > 0 &&
              invoiceLineDetails?.map((lineitem, index) => {
                return (
                  <>
                    <div className="px-[32px]">
                      <div className="flex flex-row font-[400] leading-[21.79px] pb-[16px] pt-[14px] text-[16px] w-full">
                        <div className="w-[66%]">
                          {lineitem.rateDescription}
                        </div>
                        <div className="text-end w-[7%]">
                          {lineitem.quantity}
                        </div>
                        <div className="text-end w-[15%]">
                          ${lineitem.amount}
                        </div>
                        <div className="text-end w-[12%]">
                          ${lineitem.itemTotal}
                        </div>
                      </div>
                    </div>
                    <div className="px-[32px]">
                      {index !== invoiceLineDetails?.length - 1 && (
                        <hr className="border-line-thick w-full" />
                      )}
                    </div>
                  </>
                );
              })}
            <div className="px-[32px]">
              <hr className="!border !border-[#A09F9F] border-line-thick w-full" />
            </div>
            <div className="px-[32px]">
              <div className="flex flex-row font-[400] leading-[21.79px] text-[16px] w-full">
                <div className="border-bottom-line-thick font-[600] leading-[21.79px] text-[16px] w-full">
                  <p className="pb-[8px] pt-[16px] text-end">Subtotal:</p>
                </div>
                <div className="border-bottom-line-thick w-[12%]">
                  <p className="pb-[8px] pt-[16px] text-end">
                    {invoiceTotals &&
                      invoiceTotals?.length > 0 &&
                      invoiceTotals[0]?.invoiceSubTotal}
                  </p>
                </div>
              </div>
            </div>
            <div className="px-[32px]">
              <div className="flex flex-row font-[400] leading-[21.79px] text-[16px] w-full">
                <div className="border-bottom-line-thin font-[600] leading-[21.79px] text-[16px] w-full">
                  <p className="pb-[8px] pt-[16px] text-end">Tax</p>
                </div>
                <div className="border-bottom-line-thin w-[12%]">
                  <p className="pb-[8px] pt-[16px] text-end">
                    {invoiceTotals &&
                      invoiceTotals?.length > 0 &&
                      invoiceTotals[0]?.invoicetax}
                  </p>
                </div>
              </div>
            </div>
            <div className="px-[32px]">
              <hr className="!border !border-[#A09F9F] border-line-thick float-right w-[20%]" />
            </div>
            <div className="mb-[95px] px-[32px]">
              <div className="flex flex-row font-[700] leading-[21.79px] text-[16px] w-full">
                <div className="font-[700] leading-[21.79px] text-[16px] w-full">
                  <p className="pb-[25px] pt-[16px] text-end">Total</p>
                </div>
                <div className="font-[700] leading-[21.79px] text-[16px] w-[12%]">
                  <p className="pb-[25px] pt-[16px] text-end">
                    {invoiceTotals &&
                      invoiceTotals?.length > 0 &&
                      invoiceTotals[0].netAmountDue}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSummary;
